import styled from 'styled-components';

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.spaces.space4} 0;
`;
